import { getStore } from '../store/Store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { mutatorAction } from 'satcheljs';
import {
    OwsOptionsFeatureType,
    getDefaultOptions,
    MailLayoutOptions,
} from 'owa-outlook-service-options';

const initializeSingleLineViewWithRightReadingPane = mutatorAction(
    'initializeSingleLineViewWithRightReadingPane',
    () => {
        getStore().useSingleLineMessageListWithRightReadingPane = getIsEnabledFromPrimeSettings();
    }
);

const getIsEnabledFromPrimeSettings = () => {
    const primeSettingsItems = getUserConfiguration()?.PrimeSettings?.Items;
    const primeListMailLayoutOptions: any[] | undefined = primeSettingsItems?.filter(
        item => item?.Id == 'MailLayoutOptions'
    );

    const mailLayoutOptions =
        primeListMailLayoutOptions?.[0]?.Value?.options?.[0] ||
        (getDefaultOptions()[OwsOptionsFeatureType.MailLayout] as MailLayoutOptions);

    return mailLayoutOptions?.useSingleLineMessageListWithRightReadingPane;
};

export default initializeSingleLineViewWithRightReadingPane;
